import React, { Component } from "react";

interface IProps {
  //title: string;
  failure?: any;
  errors: string[];
  hideTitle?: boolean;
}

export class ErrorBox extends Component<IProps, any> {
  render() {
    return (
      <div className="row">
        <div className="column1">
          <div className="errorbox">
            {this.props.hideTitle !== true && (
              <div className="row tight align-s">
                {!!this.props.failure ? (
                  <span className="e">
                    <strong>{this.props.failure}</strong>
                  </span>
                ) : (
                  <span className="e">
                    <strong>
                      There was a problem with your submission. Please review
                      the fields below.
                    </strong>
                  </span>
                )}
              </div>
            )}
            <div className="row tight align-s">
              <ul>
                {this.props.errors.map((v, i) => {
                  return (
                    <li key={`${v}-${i}`} className="e">
                      {v}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
